// -----------------------------------------------------------------------------
//  Brochure catalogue — Publuu-hosted flip-books, one per accommodation.
//
//  Data shape kept intentionally minimal so operators can drop a new
//  brochure in a single edit:
//    { id, hotelSlug, name: {en, fr, es}, publuuUrl, pdfUrl? }
//
//  `publuuUrl` is the *iframe src* only — the page injects width/height/
//  attributes so all cards render identically without needing to remember
//  the Publuu embed boilerplate.
//
//  `pdfUrl` is optional — when omitted, `getBrochurePdfUrl(publuuUrl)`
//  derives Publuu's own download URL from the flip-book id embedded in
//  the src. Set this field manually only when the PDF is hosted elsewhere
//  (Bunny, S3, etc.).
//
//  Ordering here defines the on-page ordering.
// -----------------------------------------------------------------------------

// Publuu embed URLs follow the pattern
//   https://publuu.com/flip-book/{userId}/{bookId}/page/{n}?embed&transparent
// and the download URL is
//   https://publuu.com/flip-book/{userId}/{bookId}/download.pdf
// The server responds with an SPA that immediately triggers the PDF
// download (or presents the viewer's download screen when the book owner
// hasn't enabled direct downloads yet). Opening it in a new tab is always
// safe.
export const getBrochurePdfUrl = (brochure) => {
  if (brochure?.pdfUrl) return brochure.pdfUrl;
  const src = brochure?.publuuUrl || "";
  const match = src.match(/flip-book\/(\d+)\/(\d+)/);
  if (!match) return null;
  return `https://publuu.com/flip-book/${match[1]}/${match[2]}/download.pdf`;
};

const BROCHURES = [
  {
    id: "kasbah-hotel-xaluca-arfoud",
    hotelSlug: "kasbah-hotel-xaluca-arfoud",
    name: {
      en: "Kasbah Hotel Xaluca",
      fr: "Kasbah Hotel Xaluca",
      es: "Kasbah Hotel Xaluca",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2477104/page/4?embed&transparent",
  },
  {
    id: "kasbah-hotel-tombouctou",
    hotelSlug: "kasbah-hotel-tombouctou",
    name: {
      en: "Kasbah Hotel Tombouctou",
      fr: "Kasbah Hotel Tombouctou",
      es: "Kasbah Hotel Tombouctou",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2477223/page/1?embed&transparent",
  },
  {
    id: "hotel-xaluca-dades",
    hotelSlug: "hotel-xaluca-dades",
    name: {
      en: "Hotel Xaluca Dades",
      fr: "Hotel Xaluca Dades",
      es: "Hotel Xaluca Dades",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2477300/page/1?embed&transparent",
  },
  {
    id: "hotel-xaluca-spa-aguelmame-sidi-ali",
    hotelSlug: "hotel-xaluca-spa-aguelmame-sidi-ali",
    name: {
      en: "Hotel Xaluca Spa Aguelmame Sidi Ali",
      fr: "Hotel Xaluca Spa Aguelmame Sidi Ali",
      es: "Hotel Xaluca Spa Aguelmame Sidi Ali",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2477400/page/1?embed&transparent",
  },
  {
    id: "hotel-riad-xaluca",
    hotelSlug: "hotel-riad-xaluca",
    name: {
      en: "Hotel Riad Xaluca",
      fr: "Hotel Riad Xaluca",
      es: "Hotel Riad Xaluca",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2478821/page/1?embed&transparent",
  },
  {
    id: "auberge-bivouacs-la-belle-etoile",
    hotelSlug: "auberge-la-belle-etoile",
    name: {
      en: "Auberge Bivouacs La Belle Étoile",
      fr: "Auberge Bivouacs La Belle Étoile",
      es: "Auberge Bivouacs La Belle Étoile",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2478831/page/1?embed&transparent",
  },
  {
    id: "kamkamia-luxury-desert-camp",
    hotelSlug: "kamkamia-luxury-desert-camp",
    name: {
      en: "Kamkamia Luxury Desert Camp",
      fr: "Kamkamia Luxury Desert Camp",
      es: "Kamkamia Luxury Desert Camp",
    },
    publuuUrl: "https://publuu.com/flip-book/1044718/2483800/page/1?embed&transparent",
  },
];

export default BROCHURES;
